import { IReCaptcha } from "./recaptcha";

export class OtherReCaptchaService implements IReCaptcha {

    public static readonly $inject: Array<string> = ["$q"];

    constructor(public $q: angular.IQService) { }

    getReCaptcha(params: { [key: string]: any; }, callback?: Function | undefined): angular.IPromise<string> {
        let defer = this.$q.defer<string>();

        defer.reject({
            successs: false,
            code: "",
            message: "Other verification code services are not supported now."
        });

        return defer.promise;
    }
}